export const copy = obj => JSON.parse(JSON.stringify(obj));
